import { render, staticRenderFns } from "./BrillaForm.vue?vue&type=template&id=b3bee630"
import script from "./BrillaForm.vue?vue&type=script&lang=js"
export * from "./BrillaForm.vue?vue&type=script&lang=js"
import style0 from "./BrillaForm.vue?vue&type=style&index=0&id=b3bee630&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports